import { render, staticRenderFns } from "./WorkDocsSchemeTypeTableItem.vue?vue&type=template&id=037b86d2&"
import script from "./WorkDocsSchemeTypeTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkDocsSchemeTypeTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports